import Uri from 'jsuri';

/**
 * Determines if a given URL is an external link.
 * @param {string} url - The URL to be checked.
 * @returns {boolean} True if the URL is external, false otherwise.
 */
const isExternalLink = (url: string) => {
  const uri = new Uri(url);
  const hostName = uri.host().toString();
  return hostName && (hostName === 'tools.coursera.org' || !hostName.includes('coursera.org'));
};

export default isExternalLink;
